import { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, Button, Container, Box } from '@material-ui/core';
import CustomTable from '../components/team/TableComponent';
import useVrackApi from '../hooks/useVrackApi';
import Page from '../components/Page';
import NewTemplateModal from '../components/team/NewTemplateModal';
import VMTemplatePreviewModal from '../components/team/VMTemplatePreviewModal';
import DeleteWithIcon from '../components/team/DeleteWithIcon';
import PreviewButtonComponent from '../components/team/PreviewButtonComponent';

export default function VMTemplates() {
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const openCreateModal = () => setIsCreateOpen(true);
  const closeCreateModal = () => setIsCreateOpen(false);

  const [vmTemplateList, setVmTemplateList] = useState([]);
  const { fetchData: vrackApiVMTemplateList } = useVrackApi('get', '/racks/vm');
  const getVMTemplateList = async () => {
    await vrackApiVMTemplateList({
      params: { global: true }
    })
      .then((response) => {
        console.debug('VM Templates were successfully retrieved from the API');
        setVmTemplateList(response);
      })
      .catch((error) => {
        console.debug(error);
      });
  };

  const columns = [
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'label', headerName: 'Label', flex: 1 },
    { field: 'description', headerName: 'Description', flex: 1 },
    { field: 'architecture', headerName: 'Architecture', sortable: false, flex: 1 },
    { field: 'provisioner_identity', headerName: 'Team Name', sortable: false, flex: 1 },
    {
      field: 'actions',
      headerName: '',
      sortable: false,
      flex: 1,
      renderCell: (param) => (
        <Box sx={{ textAlign: 'right', width: '100%' }}>
          <PreviewButtonComponent
            type="icononly"
            variant="contained"
            data={param.row}
            tooltipTitle="Preview VM Template"
            ModalComponent={VMTemplatePreviewModal}
            modalProps={{
              vm: param.row
            }}
          />
          <DeleteWithIcon
            type="icononly"
            variant="contained"
            data={param.row.name}
            onDeleted={getVMTemplateList}
            title={`Delete VM Template (${param.row.name})`}
            content="Are you sure you wish to delete the VM Template?"
            toolTipTitle="Delete VM Template"
            snackBarSuccessMessage="VM Template delete request successful"
            snackBarFailureMessage="VM Template delete request failed: "
            endpoint={`/racks/vm/${param.row.name}`}
          />
        </Box>
      )
    }
  ];

  useEffect(() => {
    getVMTemplateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Teams | VM Templates | Virtual Racks">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            title="VM Templates"
            subheader="View and manage team-created VM templates"
            action={
              <Button
                data-testid="create-template-btn"
                color="primary"
                variant="contained"
                onClick={openCreateModal}
                sx={{ mt: 2 }}
              >
                Create Template
              </Button>
            }
          />
          <CardContent>
            <CustomTable data={vmTemplateList} getData={getVMTemplateList} columns={columns} />
            <NewTemplateModal
              isOpen={isCreateOpen}
              closeHandler={closeCreateModal}
              vmTemplates={vmTemplateList}
              getVMTemplateList={getVMTemplateList}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
